// Tiny helpers to compute IST date/hour on the client so we can validate cached values
// without waiting for a network round-trip.
export function istNow() {
  return new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
}

export function istDateStr() {
  const d = istNow();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

// Common Number rolls over to the next date at 20:00 IST
export function istActiveCommonDateStr() {
  const d = istNow();
  if (d.getHours() >= 20) {
    d.setDate(d.getDate() + 1);
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function readCache(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
}

export function writeCache(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch (_e) { /* quota */ }
}
